export { IconsPlug1 } from "./IconsPlug1";
